import { Injectable } from '@angular/core';
import { AuthorizationRequest } from '../model/authorization-request.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthorizationResponse } from '../model/authorization-response.model';
import { ApiCommunicationService } from './api-communication.service';
import { first } from 'rxjs/operators';
import { User } from '../model/user.model';
import { AuthorizationResult } from '../model/authorization-result.model';


@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  private authorizationNotifier$: BehaviorSubject<AuthorizationResult> = new BehaviorSubject({ isAuthorized: false });
  private isAuthorizationInProgressNotifier$: BehaviorSubject<boolean> = new BehaviorSubject(false );
  private credentials: AuthorizationResponse;
  private user: User;

  constructor(private apiCommunicationService: ApiCommunicationService) {
  }

  login(authorizationDetails: AuthorizationRequest): Promise<AuthorizationResult> {
    this.isAuthorizationInProgressNotifier$.next(true);
    return new Promise<AuthorizationResult>(resolve => {
      setTimeout(() => {
        const result: AuthorizationResult = {
          isAuthorized: false
        };
        this.apiCommunicationService.login(authorizationDetails).pipe(first()).subscribe(credentials => {
          const isAuthorized = credentials !== undefined;
          if (isAuthorized) {
            this.credentials = credentials;
            this.apiCommunicationService.getUser(authorizationDetails.username).pipe(first()).subscribe(user => {
              result.isAuthorized = true;
              this.user = user;
              this.authorizationNotifier$.next(result);
              resolve(result);
            });
          } else {
            this.authorizationNotifier$.next(result);
            resolve(result);
          }
        }, error => {
          result.error = error;
          resolve(result);
        });
      });
    });
  }

  logout(): Observable<AuthorizationResult> {
    const result: AuthorizationResult = {
      isAuthorized: false
    };
    this.apiCommunicationService.logout().pipe(first()).subscribe(() => {
      this.authorizationNotifier$.next(result);
    }, error => {
      result.error = error;
    });
    return this.isAuthorized();
  }

  isAuthorized(): Observable<AuthorizationResult> {
    return this.authorizationNotifier$.asObservable();
  }

  isAuthorizationInProgress(): Observable<boolean> {
    return this.isAuthorizationInProgressNotifier$.asObservable();
  }

  getAuthorizationCredentials(): AuthorizationResponse {
    return this.credentials;
  }

  getUser(): User {
    return this.user;
  }
}
